<template>
  <div class="m-1" v-if="props.helper">
    <small class="block leading-normal text-xs ion-text-grey">{{ props.helper }}</small>
  </div>
</template>
<script setup>
const props = defineProps(['helper']);
</script>